// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"108565163fe3bbb7e6f4","883":"452f4cc05bc36a7bef4a","954":"90772346d9bf6a9caf37"}[chunkId] + ".js";
};